import { apiConfig } from "./apiConfig";
import { handleResponse, handleError } from "./apiHelper";

export const userApi = {
  createUser,
  updateUser,
  deleteUser,
  getUser
};

const url = apiConfig.rideumHotelUrl;

function createUser(tenant_id, tenant_name, email, role, first_name, last_name, status) {
	var gql = {
    query: `mutation CreateUser {
			create_user (
        tenant_id: "${tenant_id}"
        tenant_name: "${tenant_name}"
				email: "${email}", 
				role: "${role}",
				first_name: "${first_name}", 
				last_name: "${last_name}",
        status: "${status}"
        comment: ""
	    ) {
        uid
      }
    }`,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${apiConfig.getRideumToken()}`,
      "Content-Type": "application/json-patch+json",
    },
    body: JSON.stringify(gql),
  };

  return fetch(url, requestOptions)
    .then(handleResponse, handleError)
    .then((data) => { return data; });
}


function updateUser(uid, role, first_name, last_name, status) {
	var gql = {
    query: `mutation UpdateUser {
			update_user (
        uid: "${uid}"
				role: "${role}",
				first_name: "${first_name}", 
				last_name: "${last_name}",
        status: "${status}",
        comment: ""
      ) {
        uid
      }
		}`,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${apiConfig.getRideumToken()}`,
      "Content-Type": "application/json-patch+json",
    },
    body: JSON.stringify(gql),
  };

  return fetch(url, requestOptions)
    .then(handleResponse, handleError)
    .then((data) => { return data; });
}


function deleteUser(uid) {
	var gql = {
    query: `mutation DeleteUser {
			delete_user ( uid: "${uid}" ) {
        uid
      }
		}`,
  };
  const requestOptions = {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${apiConfig.getRideumToken()}`,
      "Content-Type": "application/json-patch+json",
    },
    body: JSON.stringify(gql),
  };

  return fetch(url, requestOptions)
    .then(handleResponse, handleError)
    .then((data) => { return data; });
}

function getUser(mapped_id) {
	var gql = {
    query: `query MyQuery {
      users(where: {mapped_id: {_eq: "${mapped_id}"}},is_deleted: {_eq: false}}) {
        created_at
        email
        first_name
        id
        last_name
        role
        status
        tenant_id
        tenant_group_id
        updated_at
        tenant {
          address_1
          address_2
          city
          country
          e_country {
            comment
            id
          }
          locale_id
          locale {
            country
            currency_code
            decimal_seperator
            id
            precision
            thousand_seperator
          }
          created_at
          email
          id
          name
          phone_no
          region
          status
          updated_at
          zip_code
          mapped_id
      }
    }
  }
    `,
  };

  const url = apiConfig.hasuraUrl;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-hasura-admin-secret": apiConfig.hasuraSecret,
      "Content-Type": "application/json-patch+json",
    },
    body: JSON.stringify(gql),
  };

  return fetch(url, requestOptions)
    .then(handleResponse, handleError)
    .then((data) => { return data; });
}